/* src/app/modules/admin/event/event.component.css */
.adminHeadTable {
  margin: 0px 20px 20px;
  width: 100%;
}
.adminBodyTable {
  margin: 0px 20px 0px;
  width: 100%;
}
.activated {
  background-color: green;
  color: white;
}
.desactivated {
  background-color: red;
  color: white;
}
.optionMenu {
  margin-right: 10px;
}
/*# sourceMappingURL=event.component.css.map */
